'use es6';

import { createSelector } from 'reselect';
import { findNode } from 'simple-menus-core/utils/menuTree';
import { getMenuNodesById } from 'simple-menus-core/selectors/menuNode';
import { getPagesById } from 'simple-menus-core/selectors/pages';
import { getUniqueDraftPages } from 'simple-menus-core/utils/menuTree';
export const getMenuTree = (state, props) => state.tree[props.menuId] || [];
export const getMenuTreeNode = (state, props) => findNode(props.id, state.tree[props.menuId]);
export const makeGetCompleteMenuTree = () => {
  return createSelector([getMenuTree, getMenuNodesById], (menuTree, nodesById) => {
    const createTree = node => {
      const nodeData = nodesById[node.id];
      const children = node.children.map(createTree);
      return Object.assign({}, nodeData, {
        children
      });
    };
    return menuTree.map(createTree);
  });
};
const getMaxDepth = (tree, maxDepth = 1) => {
  if (!tree.children.length) return maxDepth;
  return Math.max(...tree.children.map(node => {
    return getMaxDepth(node, maxDepth + 1);
  }));
};
export const makeGetMaxMenuDepth = () => {
  return createSelector([getMenuTree], menuTree => {
    if (!menuTree.length) return 0;
    return Math.max(...menuTree.map(node => {
      return getMaxDepth(node);
    }));
  });
};
export const makeGetDraftPagesForMenu = () => {
  const getCompleteMenuTree = makeGetCompleteMenuTree();
  return createSelector([getCompleteMenuTree, getPagesById], (menuTree, pagesById) => {
    if (!menuTree) return [];
    return getUniqueDraftPages(menuTree, pagesById);
  });
};